var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouritedCarousel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouritedCarousel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.1717448,11.4912016 C25.6638295,11.0150551 25.8375359,10.3162429 25.6252837,9.66663589 C25.4125309,9.01702886 24.8583724,8.55330786 24.1775634,8.45489762 L18.1243704,7.58163095 C17.866564,7.54435434 17.6437993,7.38381641 17.5286625,7.1517074 L14.8224467,1.70634051 C14.5185856,1.09450712 13.9018528,0.714285714 13.214536,0.714285714 C12.5277199,0.714285714 11.910987,1.09450712 11.6071259,1.70634051 L8.90040953,7.15220442 C8.78527271,7.38431344 8.56200741,7.54485136 8.30420106,7.58212797 L2.25100804,8.45539464 C1.57069963,8.55330786 1.01604053,9.01752589 0.803287715,9.66713291 C0.591035495,10.3167399 0.764741911,11.0155521 1.25682666,11.4916986 L5.63653106,15.7302975 C5.82325294,15.9112133 5.90885466,16.1716525 5.86480232,16.4261275 L4.83157453,22.4112596 C4.73996567,22.9381024 4.87913104,23.4505315 5.22253911,23.8546099 C5.75617323,24.4843361 6.68778026,24.6761863 7.43266541,24.2875156 L12.8460982,21.4614517 C13.0723671,21.3436576 13.3572055,21.3446516 13.5829738,21.4614517 L18.9969072,24.2875156 C19.2602201,24.4251905 19.5410538,24.4947735 19.8308982,24.4947735 C20.360027,24.4947735 20.8616231,24.2611734 21.2065329,23.8546099 C21.5504416,23.4505315 21.6891064,22.9371083 21.5974975,22.4112596 L20.5637691,16.4261275 C20.5197168,16.1711555 20.6053185,15.9112133 20.7920404,15.7302975 L25.1717448,11.4912016 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFavouritedCarousel"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#10C2E1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouritedCarousel);
export default __webpack_public_path__ + "static/media/icFavouritedCarousel.213128e71bdab7ec009e4edaf2e813fd.svg";
export { ForwardRef as ReactComponent };